module.exports = __webpack_public_path__ + "static/img/saas.99b5ea2.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/saas.png
// module id = Lqmr
// module chunks = 0